import { render } from "./Bank.vue?vue&type=template&id=54d1f49f"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"

import "./Bank.vue?vue&type=style&index=0&id=54d1f49f&lang=less"
script.render = render

export default script